import { ajaxRetry } from '../ajaxRetry';
import { CreateAccessTokenResponse } from '../../models/authentication';

import { base, createApiURL, ResponseObj } from './base';

type TokenPayload = {
  clientId: string;
  authorizationCode: string;
};

export const token = async ({
  clientId,
  authorizationCode,
}: TokenPayload): Promise<ResponseObj<CreateAccessTokenResponse>> => {
  const headers = base.headers();

  return ajaxRetry<CreateAccessTokenResponse>({
    data: JSON.stringify({
      clientId,
      code: authorizationCode,
    }),
    headers,
    method: 'POST',
    url: createApiURL('/link/v1/authentication/token'),
  });
};
